import { MapPin, Phone, Clock, Navigation, Users, TrendingUp } from "lucide-react";

const formatVisits = (n) => {
  if (n == null) return null;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return `${n}`;
};

export const StoreCard = ({ store, active, onClick, index = 0, visitsLast30Days }) => {
  const handleDirections = (e) => {
    e.stopPropagation();
    const url = `https://www.google.com/maps/dir/?api=1&destination=${store.latitude},${store.longitude}&destination_place_id=&travelmode=driving`;
    window.open(url, "_blank", "noopener");
  };

  const visitsText = formatVisits(visitsLast30Days);

  return (
    <article
      data-testid={`store-card-${store.id}`}
      onClick={() => onClick && onClick(store.id)}
      className={`group relative cursor-pointer rounded-2xl p-5 zl-rise transition-all duration-200 ${
        active
          ? "bg-zinc-900 border border-[#FF5612] shadow-[0_8px_32px_-8px_rgba(255,86,18,0.4)]"
          : "bg-zinc-900/60 border border-zinc-800 hover:border-zinc-700 hover:bg-zinc-900 hover:-translate-y-0.5"
      }`}
      style={{ animationDelay: `${index * 50}ms` }}
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1.5 flex-wrap">
            <span className="text-[10px] text-zinc-400 font-semibold uppercase tracking-[0.18em]">
              {store.city}
            </span>
            {store.distance_km != null && (
              <span
                data-testid={`distance-badge-${store.id}`}
                className="bg-[#FF5612] text-white text-[10px] px-2 py-0.5 rounded-full font-semibold"
              >
                {store.distance_km} km away
              </span>
            )}
          </div>
          <h3 className="font-display font-bold text-lg leading-tight tracking-tight text-white">
            {store.name}
          </h3>
        </div>
        <div
          className={`shrink-0 w-10 h-10 rounded-full flex items-center justify-center transition-colors ${
            active
              ? "bg-[#FF5612] text-white"
              : "bg-zinc-800 text-zinc-300 group-hover:bg-[#FF5612] group-hover:text-white"
          }`}
        >
          <MapPin className="w-4 h-4" />
        </div>
      </div>

      {/* Visitors element */}
      {visitsText && (
        <div
          data-testid={`visitors-stat-${store.id}`}
          className="flex items-center gap-2.5 mb-3 px-3 py-2 rounded-xl bg-gradient-to-r from-[#FF5612]/10 to-transparent border border-[#FF5612]/20"
        >
          <div className="shrink-0 w-7 h-7 rounded-full bg-[#FF5612]/15 flex items-center justify-center">
            <Users className="w-3.5 h-3.5 text-[#FF5612]" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-baseline gap-1.5">
              <span className="font-display font-extrabold text-base text-white tabular-nums">
                {visitsText}
              </span>
              <span className="text-xs text-zinc-300">visitors</span>
              <TrendingUp className="w-3 h-3 text-[#FF5612] ml-auto" />
            </div>
            <div className="text-[10px] text-zinc-500 uppercase tracking-[0.15em] font-medium mt-0.5">
              Last 30 days
            </div>
          </div>
        </div>
      )}

      <div className="space-y-2 text-sm text-zinc-400 leading-relaxed">
        <p>{store.address}</p>
        <div className="flex items-center gap-2 pt-2 border-t border-zinc-800">
          <Phone className="w-3.5 h-3.5 shrink-0 text-zinc-500" />
          <a
            href={`tel:${store.phone}`}
            onClick={(e) => e.stopPropagation()}
            data-testid={`store-phone-${store.id}`}
            className="text-xs text-zinc-200 hover:text-[#FF5612] transition-colors"
          >
            {store.phone}
          </a>
        </div>
        {store.hours && (
          <div className="flex items-center gap-2">
            <Clock className="w-3.5 h-3.5 shrink-0 text-zinc-500" />
            <span className="text-xs text-zinc-300">{store.hours}</span>
          </div>
        )}
      </div>

      <button
        onClick={handleDirections}
        data-testid={`directions-btn-${store.id}`}
        className="mt-4 w-full inline-flex items-center justify-center gap-2 rounded-xl bg-zinc-800 hover:bg-[#FF5612] text-white py-2.5 px-4 text-xs font-semibold transition-colors"
      >
        <Navigation className="w-3.5 h-3.5" />
        Get Directions
      </button>
    </article>
  );
};

export default StoreCard;
